(function () {
    "use strict";

    angular
        .module("Finance")
        .factory("$notification", [
            "$rootScope", "$timeout", "$log", 
            function($rootScope, $timeout, $log) {

                $rootScope.notifications = [];

                var $notification = {};
                $notification.addInfo = function(message) {
                    var notification = {
                        type: "info",
                        message: message
                    };
                    $rootScope.notifications.push(notification);
                    $timeout(function() {
                        $notification.close(notification);
                    }, 5000);
                };
                $notification.addSuccess = function(message) {
                    var notification = {
                        type: "success",
                        message: message
                    };
                    $rootScope.notifications.push(notification);
                    $timeout(function() {
                        $notification.close(notification);
                    }, 5000);
                };
                $notification.addError = function (message, response) {
                    $log.debug("ERROR");
                    $log.debug(message);
                    $log.debug(response);
                    var notification = {
                        type: "danger",
                        message: message,
                        response: response
                    };
                    $rootScope.notifications.push(notification);
                };
                $notification.close = function(notification) {
                    var index = $rootScope.notifications.indexOf(notification);
                    $rootScope.notifications.splice(index, 1);
                };

                return $notification;
            }
        ]);
})();